import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

const EvaluationGate = () => {
  const { pendingEvaluationAthleteId } = useAuth();

  if (pendingEvaluationAthleteId) {
    return <Navigate to="/athlete/onboarding" replace />;
  }

  return <Outlet />;
};

export default EvaluationGate;
